import { Form } from "antd";
import {
  GET_ALL_TNA_DEPARTMENT_DATA,
  PROBLEM_REMEDY,
  PROBLEM_REMEDY_PROBLEM,
  PROBLEM_REMEDY_PROBLEM_TYPE,
  PROBLEM_REMEDY_REASON,
} from "apiServices/API_ENDPOINTS";
import AddAndSelect from "common/AddAndSelect";
import { useEffect } from "react";

export default function AddAndEditForm({ form, data, onFinish }) {
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        tna_department_id: data?.department?.id,
        problem_type_id: data?.problem_type?.id,
        problem_id: data?.problem?.id,
        reason_id: data?.reason?.id,
        remedy_id: data?.remedy?.id,
      });
    }
  }, [data, form]);

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      {/* Department */}
      <Form.Item
        name="tna_department_id"
        label="Department"
        rules={[
          {
            required: true,
            message: "Please select or create a Department!",
          },
        ]}
      >
        <AddAndSelect
          placeholder="Select Department"
          optionUrl={GET_ALL_TNA_DEPARTMENT_DATA}
          searchKeyword="title"
          optionResponseFormat={(response) => {
            const data = response.data?.data?.data;
            return data.map((item) => ({
              label: item.title,
              value: item.id,
            }));
          }}
        />
      </Form.Item>
      <Form.Item
        name="problem_type_id"
        label="Problem Type"
        rules={[
          {
            required: true,
            message: "Please select or create a Problem Type!",
          },
        ]}
      >
        <AddAndSelect
          placeholder="Select Problem Type"
          optionUrl={PROBLEM_REMEDY_PROBLEM_TYPE}
          addUrl={PROBLEM_REMEDY_PROBLEM_TYPE}
          addResponseFormat={(response) => ({
            label: response.data.name,
            value: response.data.id,
          })}
          searchKeyword="name"
          optionResponseFormat={(response) => {
            const data = response.data?.data?.data;
            return data.map((item) => ({
              label: item.name,
              value: item.id,
            }));
          }}
        />
      </Form.Item>

      {/* Problem */}
      <Form.Item
        name="problem_id"
        label="Problem"
        rules={[
          { required: true, message: "Please select or create a Problem!" },
        ]}
      >
        <AddAndSelect
          placeholder="Select Problem"
          optionUrl={PROBLEM_REMEDY_PROBLEM}
          addUrl={PROBLEM_REMEDY_PROBLEM}
          addResponseFormat={(response) => ({
            label: response.data.name,
            value: response.data.id,
          })}
          searchKeyword="name"
          optionResponseFormat={(response) => {
            const data = response.data?.data?.data;
            return data.map((item) => ({
              label: item.name,
              value: item.id,
            }));
          }}
        />
      </Form.Item>

      {/* Reason */}
      <Form.Item
        name="reason_id"
        label="Reason"
        rules={[
          { required: true, message: "Please select or create a Reason!" },
        ]}
      >
        <AddAndSelect
          searchKeyword="name"
          placeholder="Select Reason"
          optionUrl={PROBLEM_REMEDY_REASON}
          addUrl={PROBLEM_REMEDY_REASON}
          addResponseFormat={(response) => ({
            label: response.data.name,
            value: response.data.id,
          })}
          optionResponseFormat={(response) => {
            const data = response.data?.data?.data;
            return data.map((item) => ({
              label: item.name,
              value: item.id,
            }));
          }}
        />
      </Form.Item>

      {/* Remedy */}
      <Form.Item
        name="remedy_id"
        label="Remedy"
        rules={[
          { required: true, message: "Please select or create a Remedy!" },
        ]}
      >
        <AddAndSelect
          placeholder="Select Remedy"
          searchKeyword="name"
          optionUrl={PROBLEM_REMEDY}
          addUrl={PROBLEM_REMEDY}
          addResponseFormat={(response) => ({
            label: response.data.name,
            value: response.data.id,
          })}
          optionResponseFormat={(response) => {
            const data = response.data?.data?.data;
            return data.map((item) => ({
              label: item.name,
              value: item.id,
            }));
          }}
        />
      </Form.Item>
    </Form>
  );
}
